import React, {Component} from "react";
import CommToolContext from "../common/comm_tool_context";
import Team from "../startproj/Team";
import {withRouter} from "react-router-dom";
import ExitButton from "../../components/ExitButton";

class ProjectTeam extends Component {
    render() {
        return (
            <CommToolContext.Consumer>
                {context => (
                    <div className="container-fluid">
                        <div>
                            <Team project={this.props.project}
                                  context={context}
                                  status={this.props.status}/>
                        </div>
                    </div>
                )}
            </CommToolContext.Consumer>
        );
    }
}
ProjectTeam.contextType = CommToolContext;
export default withRouter(ProjectTeam);

